import { UserOutlined } from '@ant-design/icons';
import { List, Popover, Spin, Tag, Typography, theme } from 'antd';
import type React from 'react';
import { useState } from 'react';
import { Link } from 'react-router';
import { useSearchUsers } from '../../../api/user.queries.ts';

export const AssignedUsersPopover: React.FC<{ accountId: string; count: number }> = ({ accountId, count }) => {
  const { token } = theme.useToken();
  const [open, setOpen] = useState(false);

  const { data, isLoading } = useSearchUsers(
    {
      accountId,
      page: 1,
      pageSize: 100,
      search: undefined,
    },
    { enabled: open }
  );

  const users = data?.items ?? [];

  if (count === 0) return <Typography.Text type="secondary">–</Typography.Text>;

  return (
    <div onClick={e => e.stopPropagation()}>
      <Popover
        title={
          <>
            <UserOutlined style={{ marginRight: token.marginXXS }} /> Zugeordnete Benutzer
            <br />
            <Link to={`/admin/benutzer?accountId=${encodeURIComponent(accountId)}`} style={{ fontSize: token.fontSizeSM }}>
              In Benutzerverwaltung anzeigen
            </Link>
          </>
        }
        trigger="click"
        open={open}
        onOpenChange={setOpen}
        content={
          isLoading ? (
            <Spin size="small" />
          ) : (
            <List
              size="small"
              style={{ maxHeight: 300, overflowY: 'auto' }}
              dataSource={users}
              renderItem={user => (
                <List.Item style={{ padding: '4px 0' }}>
                  <Typography.Text>
                    {user.firstName} {user.lastName}
                  </Typography.Text>
                  <Typography.Text type="secondary" style={{ marginLeft: 8 }}>
                    {user.username}
                  </Typography.Text>
                  {user.disabled && (
                    <Tag color="default" style={{ marginLeft: 8 }}>
                      inaktiv
                    </Tag>
                  )}
                </List.Item>
              )}
            />
          )
        }
      >
        {/* biome-ignore lint/a11y/useValidAnchor: Popover trigger, not a navigation link */}
        <a>
          {count} <UserOutlined />
        </a>
      </Popover>
    </div>
  );
};
